import { IEnumResponse } from '@/types'
import { autoCapitalize } from '@/utils/autoCapitalize'

export class GetCouncilListCoreMapper {
  static toDomain(persistenceData: IEnumResponse) {
    return {
      key: persistenceData?.key,
      value: persistenceData?.value,
      name: persistenceData?.key,
      descriptionWithName: `${persistenceData.key} (${autoCapitalize(
        persistenceData.value || '',
      )})`,
    }
  }
}
